import Vue from 'vue';
// import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import VueCookies from 'vue-cookies';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';

import Config from '@/config/vueconfig.js';
import Validator from '@/plugins/Validator.js';
import ga from '@/plugins/GA.js';
import BBEnumCampaignType from '@/plugins/BBEnumCampaignType.js';
import RegExp from '@/plugins/RegExp.js';
import Filter from '@/plugins/Filter.js';
import Account from '@/helper/AccountHelper.js';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false
Vue.use(VueCookies);
Vue.use(Config);
Vue.use(Validator);
Vue.use(ga);
Vue.use(BBEnumCampaignType);
Vue.use(RegExp);
Vue.use(Filter);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)

new Vue({
    router,
    render: h => h(App),
    created: function () {
        Vue.initFinished = false;

        Vue.use(VueAnalytics, {
            id: Vue.bzbsConfig.bzbsGaId,
            autoTracking: {
                page: false
            },
        });

        Account.initial();
        this.initGtmTracking();
    },
    methods: {
        initGtmTracking: function() {
            // Define the configuration object for vue-gtm
             const gtmOptions = {
                 id: Vue.bzbsConfig.bzbsGaId, // Replace 'GTM-MTXXDLC2' with your actual GTM container ID
                 enabled: true,
                 debug: false,
                 vueRouter: router,
                 loadScript: true
             };
 
             // Initialize vue-gtm with the configuration options
             Vue.use(VueGtm, gtmOptions);
             // console.log('VueGtm', VueGtm)
         }
    }
}).$mount('#app')
